<template>
   <div v-if="this.$store.getters.GetBlock.notifications"></div>
    <div  v-if="this.$store.getters.Loaded && this.$store.getters.GetBlock.location" class="uk-container uk-container-center uk-text-center uk-margin-top uk-position-z-index-negative" style="background-image: none;" uk-scrollspy="cls:uk-animation-slide-bottom;">
        <h1 class="uk-heading uk-margin-top" id="location">{{this.$store.getters.GetText.location.title[this.$store.getters.Lang]}}</h1>
        <h3>{{this.$store.getters.GetText.location.subtitle[this.$store.getters.Lang]}}</h3>
        <div class="uk-position-relative uk-light uk-margin-medium-bottom" uk-slideshow>

            <ul class="uk-slideshow-items uk-position-z-index-negative">
                <li>
                    <img src="../assets/img/location/location-0.jpg" alt="" uk-cover>
                </li>
                <li>
                    <img src="../assets/img/location/location-1.jpg" alt="" uk-cover>
                </li>
                <li>
                    <img src="../assets/img/location/location-2.jpg" alt="" uk-cover>
                </li>
                <li>
                    <img src="../assets/img/location/location-3.jpg" alt="" uk-cover>
                </li>
                <li>
                    <img src="../assets/img/location/location-4.jpg" alt="" uk-cover>
                </li>
                <li>
                    <img src="../assets/img/location/location-5.jpg" alt="" uk-cover>
                </li>
                <li>
                    <img src="../assets/img/location/location-6.jpg" alt="" uk-cover>
                </li>
                <li>
                    <img src="../assets/img/location/location-7.jpg" alt="" uk-cover>
                </li>
                <li>
                    <img src="../assets/img/location/location-8.jpg" alt="" uk-cover>
                </li>

            </ul>

            <div class="uk-position-bottom-center uk-position-small">
                <ul class="uk-dotnav">
                    <li uk-slideshow-item="0"><a href="#">Item 1</a></li>
                    <li uk-slideshow-item="1"><a href="#">Item 2</a></li>
                    <li uk-slideshow-item="2"><a href="#">Item 3</a></li>
                    <li uk-slideshow-item="3"><a href="#">Item 4</a></li>
                    <li uk-slideshow-item="4"><a href="#">Item 5</a></li>
                    <li uk-slideshow-item="5"><a href="#">Item 6</a></li>
                    <li uk-slideshow-item="6"><a href="#">Item 7</a></li>
                    <li uk-slideshow-item="7"><a href="#">Item 8</a></li>
                    <li uk-slideshow-item="8"><a href="#">Item 9</a></li>                   
                </ul>
            </div>
            <a class="uk-slidenav-large uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
            <a class="uk-slidenav-large uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slideshow-item="next"></a>
        </div>
        <div v-html="this.$store.getters.GetText.location.footer[this.$store.getters.Lang]" class="uk-container"></div>
        
    </div>
</template>

